<template>
  <div>
    <!--直播概要-->
    <div class="box study_detail_top" :style="boxMargin">
      <div class="wrap w1200">
        <div class="tit" style="margin-bottom: 0;">
          <dl>
            <dt>首页-直播学习-{{params.name}}</dt>
            <dd>
              <a class="back_btn" onclick="history.go(-1)">返回</a>
            </dd>
          </dl>
        </div>
        <!--左侧直播图片-->
        <div class="col_1 w500 de_play">
          <img src="@/assets/images/shikan.jpg" alt="试看直播">
        </div>
        <!--/左侧直播图片-->
        <!--右侧直播介绍-->
        <div class="col_2 w645 de_con_top">
          <h2>{{params.name}}</h2>
          <div v-html="params.outline"></div>
        </div>
        <!--/右侧直播介绍-->
        <div class="clear"></div>
        <div class="de_cat_all">
          <div class="col_1">
            <dl>
              <dt>开始时间</dt>
              <dd><a v-if="params.startTime">{{params.startTime}}</a><b v-if="!params.startTime">暂无</b></dd>
            </dl>
            <dl>
              <dt>直播状态</dt>
              <dd><b v-if="!params.timeStateName">暂无</b><b v-if="params.timeStateName">{{params.timeStateName}}</b></dd>
            </dl>
            <dl>
              <dt>有效期限</dt>
              <dd><b>不限期</b></dd>
            </dl>
            <dl>
              <dt>学习人数</dt>
              <dd><span>{{params.livePersonCnt}}</span>人</dd>
            </dl>
            <dl>
              <dt>讲师</dt>
              <dd>
                <b v-if="params.livePlayTeacherList && params.livePlayTeacherList.length>0">{{params.livePlayTeacherList[0].teacherName}}</b><a v-if="params.livePlayTeacherList && params.livePlayTeacherList.length>1">等</a>
                <b v-if="!params.livePlayTeacherList">讲师：暂无</b>
              </dd>
            </dl>
          </div>
          <div class="col_2 cat_right">
            <dl v-if="livePlayBuyStatus!='1'">
              <dt>
                <p v-if="params.cost && params.cost != '0'">
                  <span v-if="params.cost && params.cost != '0'">￥{{params.cost}}</span>
                  <span v-if="!params.cost || params.cost == '0'">￥0</span>
                </p>
                <p class="mt5" v-if="params.cost && params.cost != '0'">支持支付宝、微信支付</p>
              </dt>
              <dd>
                <a href="javascript:;" v-if="params.cost && params.cost != '0'" @click="livePlay_buy(params.id)">购买直播</a>
                <a href="javascript:;" v-if="(!params.cost || params.cost == '0') && params.timeState!='3'" @click="watchLive(params)">观看直播</a>
                <a href="javascript:;" v-if="(!params.cost || params.cost == '0') && params.timeState=='3'" @click="watchLive(params)">观看回放</a>
              </dd>
            </dl>
            <dl v-if="livePlayBuyStatus=='1'"><!--已购买课程显示内容-->
              <!--<dt>
                <h4 >您已学习<span>2</span>节课</h4>
              </dt>-->
              <dd>
                <a href="javascript:;" v-if="params.timeState!='3'" @click="watchLive(params)">观看直播</a>
                <a href="javascript:;" v-if="params.timeState=='3'" @click="watchLive(params)">观看回放</a>
              </dd>
            </dl>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!--/直播概要-->
    <!--直播介绍菜单-->
    <div class="wrap box study_detail_content" style="margin-bottom:0">
      <ul class="tabs">
        <li class="tab1_1"><a href="javascript:;" name=".tab1_3">直播介绍</a></li>
        <li class="tab1_2"><a href="javascript:;" name=".tab1_4">讲师介绍</a></li>
        <!--<li class="tab1_3"><a href="#" name=".tab1_5">直播章节</a></li>-->
      </ul>
      <div class="tab_content">
        <!--直播介绍-->
        <div class="tab1_3 w1200 wrap">
          <p class="introduction_detail" v-html="params.content"></p>
        </div>
        <!--/直播介绍-->
        <!--讲师介绍-->
        <div class="tab1_4 w1200 wrap ">
          <ul class="js_con" v-for="item in teacherList" :key="item.id" v-if="teacherList && teacherList.length>0">
            <dl class="video_more"><a href="javascript:;" @click="teacher_detail(item.id)"><img src="@/assets/images/study_jsjs_play@2x.png" title="观看讲师更多教学"/></a></dl>
            <dl class="about_js">
              <dt>{{item.name}}老师</dt>
              <dd v-html="item.content"></dd>
            </dl>
            <dl class="about_right">
              <dt><img v-if="item.faceUrl" :src="item.faceUrl" /><img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/teacher_normal_img.jpg" /><br />{{item.name}}</dt>
              <dd v-html="item.title"></dd>
            </dl>
          </ul>
        </div>
        <!--/讲师介绍-->
        <!--直播章节-->
        <!--<div class="tab1_5  zj_list w1200 wrap">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr  v-for="(item, index) in courseChapterList" :key="item.id" :class="{'bgcolor': (index/2==0), '': (index/2!=0)}">
              <td width="5%" align="center"><img src="@/assets/images/study_zj_icon@2x.png"/></td>
              <td width="8%" align="left">第{{item.number}}节</td>
              <td width="60%" align="left"><a href="javascript:;">{{item.name}}</a></td>
              <td width="10%" class="time" v-if="item.status!='0' && livePlayBuyStatus=='1'">已学:{{parseFloat(item.learnHour/60).toFixed(2)}}分钟</td>
              <td width="10%" class="time">时长:{{parseFloat(item.allHour/60).toFixed(2)}}分钟</td>
              <td width="12%" v-if="(item.status=='1' || item.status=='2') && livePlayBuyStatus=='1'"><a class="s_end" href="javascript:;" @click="getChapterResource(item.sourceList[0].sourceId)">已学</a></td>
              <td width="12%" v-if="item.status=='0' && livePlayBuyStatus=='1'"><a class="s_ing" href="javascript:;" @click="getChapterResource(item.sourceList[0].sourceId)">未学</a></td>
            </tr>
          </table>
        </div>-->
        <!--/直播章节-->
      </div>
    </div>
    <!--/直播介绍菜单-->
    <v-dialog/>
    <!--直播页面弹出-->
    <div class="tan livePlay" style="display:none;">
      <div class="px_add_con rp_add_con" style="height:500px;">
        <div class="h370 rdiv" style="height:500px;">
          <h3>{{params.name}}</h3>
          <a  href="javascript:void(0);"  class="close" @click="closeViewModal()" ></a>
          <div class="h200" style="overflow-x:hidden;height:480px;">
            <div  class="video_con" style="padding-top:10px;height:420px;position:relative">
              <!--视频-->
              <div  class="prism-player" id="J_prismPlayer" style="position: absolute"></div>
              <!--/视频-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/直播页面弹出-->
    <!--直播回看页面弹出-->
    <div class="tan livePlayWindow" style="display:none;">
      <div class="px_add_con rp_add_con" style="height:500px;">
        <div class="h370 rdiv" style="height:500px;">
          <h3>{{params.name}}</h3>
          <a  href="javascript:void(0);"  class="close" @click="closePlayVideoModal()" ></a>
          <div class="h200" style="overflow-x:hidden;height:480px;">
            <div  class="video_con" style="padding-top:10px;height:420px;">
              <!--视频-->
              <video-player  class="video-player-box"
                             ref="videoPlayer"
                             :options="playerOptions"
                             :playsinline="true"
                             customEventName="customstatechangedeventname"
                             @timeupdate="onPlayerTimeupdate($event)"
                             @ended="onPlayerEnded($event)"
                             @play="onPlayerPlay($event)"
                             @pause="onPlayerPause($event)"
                             @ready="playerReadied">
              </video-player>
              <!--/视频-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/直播回看页面弹出-->
  </div>
</template>
<script>
  import rangePermission from '@/utils/rangePermission'
  import config from '@/config'
import {init} from '@/assets/js/public'
import { getCookie } from '@/store/cookies.js'
// require styles
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
export default {
  components: { videoPlayer },
  data () {
    return {
      orgType: null,
      originPath: window.location.href,
      ori_str: '',
      params: {},
      teacherIds: [],
      resource: {},
      teacherList: [],
      livePlayBuyStatus: '2', // '0' 未支付；'1' 已支付；'2' 无支付记录
      currentPage: 1,
      pages: 0,

      playerOptions: {
        // videojs options
        muted: true,
        width: 640,
        height: 400,
        language: 'en',
        playbackRates: [1.0],
        sources: [{
          type: "video/mp4",
          src: "http://vod.bylonline.cn/9fc0cb5a737f4e08b93b3d360340dfff/a09f29b95fbd4249b74e7073dbf537e6-734884e784050aa4f71eae0abec3e9cb-ld.mp4"
        }],
        poster: ""
      },
      liveVideoList: [],
      cur_video_index: 0,
      live_video_length: 0
    }
  },
  created () {
    if (getCookie('org') && getCookie('org').businessId) {
      this.orgType=getCookie('org').businessId
      this.ori_str = this.$utils.judgementOri(this.orgType)
    } else {
      this.ori_str = ''
    }
    /* rangePermission.checkScope({ // 防盗链
      itemId: this.$route.params.id,
      itemType: '06',
      permission: '02'
    }).then((r) => {
      if (!r.data) {
        let path = (process.env.NODE_ENV == 'development') ? 'http://localhost:8081' : config.domains[0] + ':' + config.webport
        window.location.href = path
      }
    }) */
    this.livePlay_buy_status(this.$route.params.id)
    this.getLivePlayInfo(this.$route.params.id)
    this.ori_str = this.$utils.judgementOri(this.orgType)
  },
  mounted () {
    this.$nextTick(() => {
      init()
    })
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    },
    boxMargin () {
      if (this.ori_str == 'entrain') {
        return {
          marginTop: '121px'
        }
      }
    }
  },
  methods: {
    // listen event
    onPlayerPlay (player) {
    },
    onPlayerPause (player) {
    },
    onPlayerEnded (player) {
      if (this.cur_video_index < this.live_video_length-1) {
        this.cur_video_index++
        this.$refs.videoPlayer.player.src(this.liveVideoList[this.cur_video_index].reviewUrl)
        this.$refs.videoPlayer.player.play()
      } else {
        this.cur_video_index = 0
        this.$refs.videoPlayer.player.src(this.liveVideoList[this.cur_video_index].reviewUrl)
      }
    },
    // ...player event
    onPlayerTimeupdate (player) {
    },
    // player is ready
    playerReadied (player) {
    },

    getLivePlayInfo (id) {
      this.$api.get(this.$global.livePlayApiPath, '/livePlayInfo/get', {id: id}, r => {
        if (r.data) {
          this.params = r.data
          if (this.params.livePlayTeacherList && this.params.livePlayTeacherList.length>0) {
            for (let i = 0; i < this.params.livePlayTeacherList.length; i++) {
              this.teacherIds.push(this.params.livePlayTeacherList[i].teacherId)
            }
          }
          this.getTeacherListByIds(this.teacherIds)
        }
      })
    },
    enterLiveState (livePlay) {
      this.$api.post(this.$global.livePlayApiPath, '/livePlayState/save', {livePlayId: livePlay.id, state: '1'}, r => {
      })
    },
    watchLive (livePlay) {
      if (this.$TOKEN_VAL && this.$TOKEN_VAL!='') {
        var self = this
        switch (livePlay.timeState) {
          case '1':
            this.$toasted.show('直播未开始！', {
              duration: 800
            })
            break;
          case '2':
            this.$api.post(this.$global.livePlayApiPath, '/livePlayInfo/getUserPlayUrl', {appName: this.params.appName, streamName: livePlay.id}, r => {
              this.resource = r.data
              var player = new Aliplayer({
                id: 'J_prismPlayer',
                width: '100%',
                height: '400px',
                autoplay: true,
                // 支持播放地址播放,此播放优先级最高
                source: this.resource[2]
                // source: 'rtmp://live.bylonline.cn/a1/123?auth_key=1534816100-0-0-17edd68258c62a8071933965bb8a9925'
              }, function (player) {
                console.log('播放器创建好了。')
              });
              self.$utils.fadeIn('.livePlay')
              self.enterLiveState(livePlay)
            })
            break;
          case '3':
            this.$api.post(this.$global.livePlayApiPath, '/livePlayInfo/getUserReviewUrl', {streamName: livePlay.id}, r => {
              if (r.data) {
                this.liveVideoList = r.data
                this.live_video_length = this.liveVideoList.length;
                this.$refs.videoPlayer.player.src(this.liveVideoList[this.cur_video_index].reviewUrl)
                this.$utils.fadeIn('.livePlayWindow')
              } else {
                this.$toasted.show('暂无回看地址！', {
                  duration: 1000
                })
              }
            })
            break
        }
      } else {
        this.$toasted.show('请先登录！', {
          duration: 800
        })
      }
    },
    closeViewModal () {
      this.$utils.fadeOut('.livePlay')
    },
    closePlayVideoModal () {
      this.$utils.fadeOut('.livePlayWindow')
      this.cur_video_index = 0
      this.$refs.videoPlayer.player.pause()
    },
    teacher_detail (id) {
      this.$router.push({path: '/byl/teacherDetail/'+ id})
    },
    // teachers
    getTeacherListByIds (idsArr) {
      let idStr = ''
      if (idsArr && idsArr.length>0) {
        for (let i = 0; i<idsArr.length; i++) {
          if (i<idsArr.length-1) {
            idStr += idsArr[i] + ','
          } else if (i == idsArr.length-1) {
            idStr += idsArr[i]
          }
        }
      }
      this.$api.get(this.$global.teacherApiPath, '/teacher/batch', {ids: idStr}, r => {
        this.teacherList = r.data
      })
    },
    livePlay_buy_status (id) {
      this.$api.post(this.$global.livePlayApiPath, '/livePlayPay/findList', {livePlayId: id, pageNo: 0, pageSize: 0}, r => {
        if (r.data && r.data.length=='1') {
          this.courseStatus = r.data
          this.livePlayBuyStatus = this.courseStatus[0].payState
        } else {
          this.livePlayBuyStatus = '0'
        }
      })
    },
    livePlay_buy (id) {
      if (this.$TOKEN_VAL && this.$TOKEN_VAL!='') {
        this.$api.post(this.$global.livePlayApiPath, '/livePlayPay/findList', {livePlayId: id, pageNo: 0, pageSize: 0}, r => {
          if (r.data) {
            this.courseStatus = r.data
            this.livePlayBuyStatus = this.courseStatus[0].payState
          } else {
            this.livePlayBuyStatus = '2'
          }
          if (this.livePlayBuyStatus == '2') {
            this.$api.post(this.$global.livePlayApiPath, '/livePlayPay/edit', {livePlayId: id, payState: '0'}, r => {
              if (r.data) {
                this.$router.push({path: '/'+ this.ori_str +'/livePlayPay/'+ id + '/' + '2'+ '/'  + r.data.id + '/' + this.orgType + '/' + encodeURIComponent(this.originPath) + '/'  + r.data.sign})
              }
            })
          } else if (this.livePlayBuyStatus == '0') {
            let that = this
            this.$modal.show('dialog', {
              title: '支付',
              text: '该直播存在未完成支付订单，是否继续支付？',
              buttons: [
                {
                  title: '继续',
                  default: true,
                  handler: () => {
                    that.$router.push({path: '/'+ that.ori_str +'/livePlayPay/'+ id + '/' + '2'+ '/'  + that.courseStatus[0].id + '/' + that.orgType + '/' + encodeURIComponent(that.originPath) + '/'  + that.courseStatus[0].sign})
                  }
                },
                {
                  title: '取消订单',
                  handler: () => {
                    this.$api.post(this.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: that.courseStatus[0].id}, r => {
                      this.$api.post(this.$global.livePlayApiPath, 'livePlayPay/delete', {ids: that.courseStatus[0].id}, r => {
                        that.$modal.hide('dialog')
                        that.$toasted.show('订单取消成功！', {
                          duration: 800
                        })
                        that.livePlay_buy_status(id)
                      }, e => {
                        this.$toasted.show(e.message, {
                          duration: 800
                        })
                      })
                    }, e => {
                      if (e=='PAY_ERROR_00014') {
                        that.$modal.hide('dialog')
                        that.livePlay_buy_status(id)
                        that.getLivePlayInfo(id)
                      }
                    })
                  }
                }
              ]
            })
          }
        })
      } else {
        this.$toasted.show('请先登录！', {
          duration: 800
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .back_btn {
    position: absolute;
    top: 16px;
    right: 47px;
    width: 56px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 5px;
    color: #333;
    display: block;
    background: #fff;
    border: 1px solid #ccc;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/page/modules/livePlay/detail.vue